import Cookies from 'js-cookie';

const COOKIE_CONFIG = {
  name: '_trashie_io',
  domain: 'trashie.io',
  secure: true,
  expires: 30,
};

const getCookieData = (userData) => ({
  activeSubscription: userData.activeSubscription,
});

export const setCrossDomainCookie = (userData) => {
  try {
    const cookieData = getCookieData(userData);

    Cookies.set(COOKIE_CONFIG.name, JSON.stringify(cookieData), {
      domain: COOKIE_CONFIG.domain,
      secure: COOKIE_CONFIG.secure,
      expires: COOKIE_CONFIG.expires,
    });

    return true;
  } catch (error) {
    console.error('Error setting cross domain cookie:', error);
    return false;
  }
};

export const getCrossDomainCookie = () => {
  try {
    const cookieValue = Cookies.get(COOKIE_CONFIG.name);

    if (!cookieValue) {
      return null;
    }

    const cookieData = JSON.parse(cookieValue);

    if (typeof cookieData !== 'object' || cookieData === null) {
      return null;
    }

    return cookieData;
  } catch (error) {
    console.error('Error reading cross domain cookie:', error);
    return null;
  }
};

export const updateCrossDomainCookie = (userData) => {
  try {
    const existingData = getCrossDomainCookie() || {};
    const updatedData = { ...existingData, ...getCookieData(userData) };

    Cookies.set(COOKIE_CONFIG.name, JSON.stringify(updatedData), {
      domain: COOKIE_CONFIG.domain,
      secure: COOKIE_CONFIG.secure,
      expires: COOKIE_CONFIG.expires,
    });

    return true;
  } catch (error) {
    console.error('Error updating cross domain cookie:', error);
    return false;
  }
};

export const removeCrossDomainCookie = () => {
  try {
    Cookies.remove(COOKIE_CONFIG.name, {
      domain: COOKIE_CONFIG.domain,
      secure: COOKIE_CONFIG.secure,
    });
    return true;
  } catch (error) {
    console.error('Error removing cross domain cookie:', error);
    return false;
  }
};

export const isCrossDomainUserMember = () => {
  const cookieData = getCrossDomainCookie();
  return Boolean(cookieData?.activeSubscription);
};

export default {
  setCrossDomainCookie,
  getCrossDomainCookie,
  updateCrossDomainCookie,
  removeCrossDomainCookie,
  isCrossDomainUserMember,
};
